import { Injectable } from '@angular/core';

/**
 * Cookie object format
 *
 * param   name Cookie's identification
 * param   value Cookie's value
 * param   expires Cookie's expiration date in days from now or at a specific date from a Date object.
 *                  If it's undefined the cookie is a session Cookie
 * param   path Path relative to the domain where the cookie should be avaiable. Default /
 * param   domain Domain where the cookie should be avaiable. Default current domain
 * param   secure If true, the cookie will only be available through a secured connection
 */
export interface ICookie {
    name: string;
    value: string;
    expires?: number | Date;
    path?: string;
    domain?: string;
    secure?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UtilityCookieService {


    /**
     * "https://github.com/BCJTI/ng2-cookies"
	 * Checks the existence of a single cookie by it's name
	 *
	 * param name Identification of the cookie
	 * returns existence of the cookie
	 */
    public static checkCookieExists(name: string): boolean {
        name = encodeURIComponent(name);
        const regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
        const exists = regexp.test(document.cookie);
        return exists;
    }

    /**
	 * Retrieves a single cookie by it's name
	 *
	 * param name Identification of the Cookie
	 * returns The Cookie's value
	 */
    public static getCookie(name: string): string {
        if (UtilityCookieService.checkCookieExists(name)) {
            name = encodeURIComponent(name);
            const regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
            const result = regexp.exec(document.cookie);
            return decodeURIComponent(result[1]);
        } else {
            return '';
        }
    }

    /**
	 * Save the cookie
	 *
	 * param cookie Cookie name, value
	 */
    public static setCookie(cookie: ICookie) {
        // name: string, value: string, expires?: number | Date, path?: string, domain?: string, secure?: boolean) {
        let cookieStr = encodeURIComponent(cookie.name) + '=' + encodeURIComponent(cookie.value) + ';';

        if (cookie.expires) {
            if (typeof cookie.expires === 'number') {
                const dtExpires = new Date(new Date().getTime() + cookie.expires * 1000 * 60 * 60 * 24);
                cookieStr += 'expires=' + dtExpires.toUTCString() + ';';
            } else {
                cookieStr += 'expires=' + cookie.expires['toUTCString']() + ';';
            }
        }

        if (cookie.path) {
            cookieStr += 'path=' + cookie.path + ';';
        }
        if (cookie.domain) {
            cookieStr += 'domain=' + cookie.domain + ';';
        }
        if (cookie.secure) {
            cookieStr += 'secure;';
        }

        // console.log(cookieStr);
        document.cookie = cookieStr;
    }

    /**
	 * Removes specified Cookie
	 *
	 * param name Cookie's identification name
	 */
    public static deleteCookie(cookie: ICookie) {
        // If the cookie exists
        if (UtilityCookieService.getCookie(cookie.name)) {
            UtilityCookieService.setCookie(cookie);
        }
    }
  /**
   * Assert cookie value
   */
    public static assertCookieValue(cookieName: string, value: string): boolean {
      const ck: string = UtilityCookieService.getCookie(cookieName) || '';
      return ck.toLowerCase() === (value || '').toLowerCase();
    }
}
